module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff?06b3153d3d537a854dc839652018bb87";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff
// module id = XU5Z
// module chunks = 29